import { render, staticRenderFns } from "./OpenIndicator.vue?vue&type=template&id=fed7491c&scoped=true"
import script from "./OpenIndicator.vue?vue&type=script&lang=js"
export * from "./OpenIndicator.vue?vue&type=script&lang=js"
import style0 from "./OpenIndicator.vue?vue&type=style&index=0&id=fed7491c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7491c",
  null
  
)

export default component.exports